import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

/**
 * Displays impression column.
 */

export class Impression extends ProjectionGridBaseColumn {
  constructor({ deps, columnOverrider }) {
    const localizedTitle = deps.i18n.getString('LocationGrid_Column_Header_Estate_Impression');

    super({
      name: 'Impression',
      type: 'number',
      property: 'EstimatedIncreaseInImpressions',
      format: 'integer',
      title: 'LocationGrid_Column_Header_Estate_Impression',
      i18n: deps.i18n,
      helpId: 'pop_BA_LocationTargeting_EstImpr',
      sortable: true,
      helpAriaLabel: deps.i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
      ...columnOverrider.Impression,
    });
  }
}
